import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { About } from '../components/About';
import { Courses } from '../components/Courses';
import { Trainers } from '../components/Trainers';
import { Pricing } from '../components/Pricing';
import { PersonalTraining } from '../components/PersonalTraining';
import { Events } from '../components/Events';
import { Testimonials } from '../components/Testimonials';
import { Footer } from '../components/Footer';
import { StickyButton } from '../components/StickyButton';
interface HomeProps {
  onNavigate: (page: 'home' | 'rental') => void;
}
export function Home({
  onNavigate
}: HomeProps) {
  return <div className="min-h-screen bg-white" data-id="element-246">
      <Navbar onNavigate={onNavigate} data-id="element-247" />
      <Hero data-id="element-248" />
      <About data-id="element-249" />
      <Courses data-id="element-250" />
      <Trainers data-id="element-251" />
      <Pricing data-id="element-252" />
      <PersonalTraining data-id="element-253" />
      <Events onNavigate={onNavigate} data-id="element-254" />
      <Testimonials data-id="element-255" />
      <Footer onNavigate={onNavigate} data-id="element-256" />
      <StickyButton data-id="element-257" />
    </div>;
}